import React from 'react';
import Footer from './Footer';
import { useEffect,useState } from 'react';
const CancellationRefund = () => {

    const [isVisible, setIsVisible] = useState(false);
    useEffect(() => {
               window.scrollTo({ top: 0, behavior: 'auto' });
       
               const toggleVisibility = () => {
                   if (window.pageYOffset > 300) {
                       setIsVisible(true);
                   } else {
                       setIsVisible(false);
                   }
               };
       
               window.addEventListener('scroll', toggleVisibility);
       
               return () => {
                   window.removeEventListener('scroll', toggleVisibility);
               };
           }, []);
  return (
    <>
   {/* <div className="container-flude"> */}
   <div class="policy-card">
  <h3>Cancellation Policy</h3>

  <p>
    <strong>OVERAY PRIVATE LIMITED</strong> believes in helping its customers as far as possible, and has therefore a liberal cancellation policy. Under this policy:
  </p>

  <ul class="policy-list">
    <li>
      Cancellations will be considered only if the request is made within 7 days of placing the order. However, the cancellation request may not be entertained if the orders have been communicated to the vendors/merchants and they have initiated the process of shipping them.
    </li>

    <li>
      <strong>OVERAY PRIVATE LIMITED</strong> does not accept cancellation requests for perishable items like flowers, eatables, etc. However, refund/replacement can be made if the customer establishes that the quality of product delivered is not good.
    </li>

    <li>
      In case of receipt of damaged or defective items, please report the same to our Customer Service team. The request will, however, be entertained once the merchant has checked and determined the same at their own end. This should be reported within 7 days of receipt of the products.
    </li>

    <li>
      In case you feel that the product received is not as shown on the site or as per your expectations, you must bring it to the notice of our customer service within 7 days of receiving the product. The Customer Service Team, after looking into your complaint, will take an appropriate decision.
    </li>

    <li>
      In case of complaints regarding products that come with a warranty from manufacturers, please refer the issue to them.
    </li>

    <li>
      In case of any refunds approved by <strong>OVERAY PRIVATE LIMITED</strong>, it’ll take 7 days for the refund to be processed to the end customer.
    </li>
  </ul>
</div>
{/* </div> */}
      <Footer />
    </>
  );
};

export default CancellationRefund;
